import { PropsWithChildren } from 'react'

interface IHeader2 extends PropsWithChildren {
  className?: string
}

export default function Header2(props: IHeader2) {
  return <h2 className={`font-weight-600 text-xl md:text-2xl ${props.className}`}>{props.children}</h2>
}
